/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CampaignSortData from './CampaignSortData';

/**
 * The CampaignControllerDtoCampaignSortRequest model module.
 * @module model/CampaignControllerDtoCampaignSortRequest
 * @version 1.0
 */
class CampaignControllerDtoCampaignSortRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoCampaignSortRequest</code>.
     * @alias module:model/CampaignControllerDtoCampaignSortRequest
     * @param list {Array.<module:model/CampaignSortData>} 
     */
    constructor(list) { 
        
        CampaignControllerDtoCampaignSortRequest.initialize(this, list);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, list) { 
        obj['list'] = list;
    }

    /**
     * Constructs a <code>CampaignControllerDtoCampaignSortRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoCampaignSortRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoCampaignSortRequest} The populated <code>CampaignControllerDtoCampaignSortRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoCampaignSortRequest();

            if (data.hasOwnProperty('list')) {
                obj['list'] = ApiClient.convertToType(data['list'], [CampaignSortData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoCampaignSortRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoCampaignSortRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CampaignControllerDtoCampaignSortRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        if (data['list']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['list'])) {
                throw new Error("Expected the field `list` to be an array in the JSON data but got " + data['list']);
            }
            // validate the optional field `list` (array)
            for (const item of data['list']) {
                CampaignSortData.validateJSON(item);
            };
        }

        return true;
    }


}

CampaignControllerDtoCampaignSortRequest.RequiredProperties = ["list"];

/**
 * @member {Array.<module:model/CampaignSortData>} list
 */
CampaignControllerDtoCampaignSortRequest.prototype['list'] = undefined;






export default CampaignControllerDtoCampaignSortRequest;

